import { useState, useEffect, useCallback, useRef } from "react";
import { getEthersProvider } from "../web3/provider";

// Runs `reader(provider)` once on mount and on reload(). Returns { data, loading, reload }.
export function useReads(reader) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const mounted = useRef(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const provider = getEthersProvider();
      const d = await reader(provider);
      if (mounted.current) setData(d);
    } catch {
      /* ignore */
    } finally {
      if (mounted.current) setLoading(false);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    mounted.current = true;
    load();
    return () => { mounted.current = false; };
  }, [load]);

  return { data, loading, reload: load };
}
